module.exports = __webpack_public_path__ + "media/components/src/assets/images/news/news_3-dc045ec48028234ed3a0670142f2039c.jpg";